import { render, staticRenderFns } from "./SkeletonCards.vue?vue&type=template&id=1f36b9b4&scoped=true"
import script from "./SkeletonCards.vue?vue&type=script&lang=js"
export * from "./SkeletonCards.vue?vue&type=script&lang=js"
import style0 from "./SkeletonCards.vue?vue&type=style&index=0&id=1f36b9b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f36b9b4",
  null
  
)

export default component.exports